/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */

/**
 * * `fixed` - Fixed
* `recurring` - Recurring
* `unlimited` - Unlimited
 */
export type LimitTypeEnum = typeof LimitTypeEnum[keyof typeof LimitTypeEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LimitTypeEnum = {
  fixed: 'fixed',
  recurring: 'recurring',
  unlimited: 'unlimited',
} as const;
